import { render, staticRenderFns } from "./ProductDiagram.vue?vue&type=template&id=972edc54&scoped=true"
import script from "./ProductDiagram.vue?vue&type=script&lang=js"
export * from "./ProductDiagram.vue?vue&type=script&lang=js"
import style0 from "./ProductDiagram.vue?vue&type=style&index=0&id=972edc54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "972edc54",
  null
  
)

export default component.exports